import React from 'react';
import classNames from 'classnames';
import T from 'prop-types';

/* eslint-disable react/no-unknown-property */

const expandableButtonPropTypes = {
  buttonText: T.node,
  onClick: T.func,
  buttonClass: T.string,
  iconClass: T.string,
  textClass: T.string,
  /** Used for aria-collapsed and data-open attributes */
  open: T.bool,
  /** Should match ID of element being opened/closed for aria-controls attribute */
  controlsElementId: T.string,
  buttonId: T.string,
  /* Will spread on <button> element. Only use valid attributes for html button. */
  attr: T.object,
};

const ExpandableButton = (props) => {
  const {
    buttonText,
    onClick,
    buttonClass,
    iconClass,
    textClass,
    open,
    controlsElementId,
    buttonId,
    attr,
  } = props;

  return (
    <button
      type="button"
      className={`${buttonClass} c-expandable-button`}
      matomo-id="expandable-button"
      id={buttonId}
      onClick={onClick}
      aria-controls={controlsElementId}
      aria-expanded={open}
      data-open={open ? 'true' : 'false'}
      {...attr}
    >
      <i
        data-open={open ? 'true' : 'false'}
        matomo-id="expandable-button"
        id={buttonId ? `${buttonId}-i` : 'expandable-button-i'}
        className={classNames({
          [`${iconClass}`]: true,
          [`${iconClass}--is-open`]: open,
        })}
      ></i>

      <span
        aria-expanded={open}
        matomo-id="expandable-button"
        id={buttonId ? `${buttonId}-span` : 'expandable-button-span'}
        className={textClass}
      >
        {buttonText}
      </span>
    </button>
  );
};

ExpandableButton.defaultProps = {
  buttonClass: '',
  attr: {},
};

ExpandableButton.propTypes = expandableButtonPropTypes;

export default ExpandableButton;
